import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useForm } from "react-hook-form";
import { useAuth } from "./../util/auth";
import { US_STATES, COUNTRIES } from './../util/constants'; // Adjust the path as necessary
// import { savePendingSignup } from "../util/db";
import { savePendingSignup } from "../util/apiHelpers";
import { checkIfProductionNameAndCrewOrExtraKeyExists } from "../util/apiHelpers";
import PhoneMask from "./PhoneMask";

function AuthForm(props) {
  const auth = useAuth();
  const [pending, setPending] = useState(false);
  const { handleSubmit, register, errors, getValues, formState, watch } = useForm({
    mode: "onChange",
  });

  const expiryValue = watch("accessKeyForExtrasExpiry");
  const tosAccepted = watch("tosAccepted");

  const submitHandlersByType = {
    signin: ({ email, pass }) => {
      return auth.signin(email, pass).then((user) => {
        // Call auth complete handler
        props.onAuth(user);
      });
    },

    signup: async ({ email, pass, businessName, productionName, accessKey, accessKeyForExtras, accessKeyForExtrasExpiry, phone }) => {
      props.onFormAlert(null);
      const { addressLine1, addressLine2, city, state, postal_code, country } = getValues();
      const businessAddress = { addressLine1, addressLine2, city, state, postal_code, country };
      const objCrewKey = {key: accessKey, expiry: false, type: 'crew'};
      const objExtraKey = {key: accessKeyForExtras, expiry: accessKeyForExtrasExpiry, type: 'extra'};
      var productionData = {businessName: businessName, businessAddress: businessAddress, productionName: productionName, productionAccountEmail: email, accessKey: objCrewKey, accessKeyForExtras: objExtraKey, phone: phone}

      //  // Check if productionName + crewKey or productionName + extraKey already exist
      // const crewKeyExists = await checkIfProductionNameAndCrewKeyExists(productionName, accessKey);
      // const extraKeyExists = await checkIfProductionNameAndExtraKeyExists(productionName, accessKeyForExtras);

      // if (crewKeyExists || extraKeyExists) {
      //   const conflictField = crewKeyExists ? "crew key" : "extra key";
      //   props.onFormAlert({
      //     type: "error",
      //     message: `A production with this name and ${conflictField} already exists. Please choose a different production name or key.`
      //   });
      //   setPending(false);
      //   return; // stop the signup process
      // }

      try {
        const result = await checkIfProductionNameAndCrewOrExtraKeyExists(productionName, accessKey, accessKeyForExtras);
                console.log('right after checking dups')

        if (result.exists) {
          console.log('result exists')
          const conflictField =
            result.duplicateType === "crewKey"
              ? "crew key"
              : result.duplicateType === "extraKey"
              ? "extra key"
              : "key";
      
          props.onFormAlert({
            type: "error",
            message: `A production with this name and ${conflictField} already exists. Please choose a different production name or key.`,
          });
      
          setPending(false);
          return; // stop the signup process
        }
      
        // continue signup if no duplicate
      } catch (err) {
        console.error("Error checking production duplicate:", err);
        props.onFormAlert({
          type: "error",
          message: "Failed to check for duplicates. Please try again.",
        });
        setPending(false);
        return;
      }    

        const user = await auth.signup(email, pass); // user is guaranteed
        await savePendingSignup(user.uid, productionData);
        console.log('right before on auth after sav epending..')
        props.onAuth({
          user,
          productionData,
          redirectToVerify: true,
        });        
        console.log('right after onauth.. ' + JSON.stringify(user))
    },
    
    forgotpass: ({ email }) => {
      return auth.sendPasswordResetEmail(email).then(() => {
        setPending(false);
        // Show success alert message
        props.onFormAlert({
          type: "success",
          message: "Password reset email sent",
        });
      });
    },
    changepass: ({ pass }) => {
      return auth.confirmPasswordReset(pass).then(() => {
        setPending(false);
        // Show success alert message
        props.onFormAlert({
          type: "success",
          message: "Your password has been changed",
        });
      });
    },
  };

  // Handle form submission
  const onSubmit = ({ email, pass, businessName, businessAddress, productionName, accessKey, accessKeyForExtras, accessKeyForExtrasExpiry, phone }) => {
    // Show pending indicator
    setPending(true);

    // Call submit handler for auth type
    submitHandlersByType[props.type]({
      email,
      pass,
      businessName,
      businessAddress,
      productionName,
      accessKey,
      accessKeyForExtras,
      accessKeyForExtrasExpiry,
      phone
    }).catch((error) => {
      setPending(false);
      // Show error alert message
      props.onFormAlert({
        type: "error",
        message: error.message,
      });
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container={true} spacing={2}>

        {["signup"].includes(props.type) && (
          <Grid item={true} xs={12}>
            <TextField
              variant="outlined"
              type="text"
              label="Production Company"
              name="businessName"
              error={errors.businessName ? true : false}
              helperText={errors.businessName && errors.businessName.message}
              fullWidth={true}
              inputRef={register({
                required: "Please enter a business name",
              })}
            />
          </Grid>
        )}
        {/* {["signup"].includes(props.type) && (
          <Grid item={true} xs={12}>
            <TextField
              variant="outlined"
              type="text"
              label="Production Company Address"
              name="businessAddress"
              error={errors.businessAddress ? true : false}
              helperText={errors.businessAddress && errors.businessAddress.message}
              fullWidth={true}
              inputRef={register({
                required: "Please enter your business address",
              })}
            />
          </Grid>
        )} */}
        {["signup"].includes(props.type) && (
  <>
    {/* Address Line 1 */}
    <Grid item xs={12}>
      <TextField
        variant="outlined"
        label="Address Line 1"
        name="addressLine1"
        error={errors.addressLine1 ? true : false}
        helperText={errors.addressLine1 && errors.addressLine1.message}
        fullWidth
        inputRef={register({
          required: "Address Line 1 is required",
        })}
      />
    </Grid>

    {/* Address Line 2 */}
    <Grid item xs={12}>
      <TextField
        variant="outlined"
        label="Address Line 2"
        name="addressLine2"
        error={errors.addressLine2 ? true : false}
        helperText={errors.addressLine2 && errors.addressLine2.message}
        fullWidth
        inputRef={register()}
      />
    </Grid>

    {/* City */}
    <Grid item xs={12} sm={6}>
      <TextField
        variant="outlined"
        label="City"
        name="city"
        error={errors.city ? true : false}
        helperText={errors.city && errors.city.message}
        fullWidth
        inputRef={register({ required: "City is required" })}
      />
    </Grid>

    {/* State */}
    <Grid item xs={12} sm={6}>
      <TextField
        variant="outlined"
        select
        label="State"
        name="state"
        error={errors.state ? true : false}
        helperText={errors.state && errors.state.message}
        fullWidth
        inputRef={register({ required: "State is required" })}
        SelectProps={{ native: true }}
      >
            <option value=""></option>
            {US_STATES.map((state) => (
              <option key={state.code} value={state.code}>
                {state.name}
              </option>
        ))}
      </TextField>
    </Grid>

    {/* Postal Code */}
    <Grid item xs={12} sm={6}>
      <TextField
        variant="outlined"
        label="Postal Code"
        name="postal_code"
        error={errors.postal_code ? true : false}
        helperText={errors.postal_code && errors.postal_code.message}
        fullWidth
        inputRef={register({ required: "Postal Code is required" })}
      />
    </Grid>

    {/* Country */}
    <Grid item xs={12} sm={6}>
      <TextField
        variant="outlined"
        select
        label="Country"
        name="country"
        error={errors.country ? true : false}
        helperText={errors.country && errors.country.message}
        fullWidth
        inputRef={register({ required: "Country is required" })}
        SelectProps={{ native: true }}
      >
            <option value=""></option>
            {COUNTRIES.map((country) => (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
        ))}
      </TextField>
    </Grid>
  </>
)}

        {["signup"].includes(props.type) && (
          <Grid item={true} xs={12}>
            <TextField
              variant="outlined"
              type="text"
              label="Production Name for App / Map"
              name="productionName"
              error={errors.productionName ? true : false}
              helperText={errors.productionName && errors.productionName.message}
              fullWidth={true}
              inputRef={register({
                required: "Please enter production name",
              })}
              onChange={(e) => {
                e.target.value = e.target.value.toUpperCase();
              }}
            />
          </Grid>
        )}
        {["signup"].includes(props.type) && (
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            type="text"
            label="Access Key for Crew"
            name="accessKey"
            placeholder="MyShow123"
            error={!!errors.accessKey}
            helperText={errors.accessKey?.message}
            fullWidth
            inputRef={register({ required: "Please enter an access key" })}
          />
        </Grid>)}
        {["signup"].includes(props.type) && (
        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            type="text"
            label="Access Key for Extras"
            name="accessKeyForExtras"
            placeholder="MyShow123EXTRA"
            error={!!errors.accessKeyForExtras}
            helperText={errors.accessKeyForExtras?.message}
            fullWidth
            inputRef={register({ required: "Please enter an access key for Extras" })}
          />
        </Grid>)}
        {["signup"].includes(props.type) && (
        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            type="datetime-local"
            name="accessKeyForExtrasExpiry"
            label="Extras Key Expiration"
            error={!expiryValue || !!errors.accessKeyForExtrasExpiry}
            helperText={
              !expiryValue
                ? "Please enter extra key expiration"
                : errors.accessKeyForExtrasExpiry?.message
            }
            fullWidth
            inputRef={register({
              required: "Please enter extra key expiration",
            })}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>)}

        {["signup"].includes(props.type) && (
        <Grid item xs={12}>
            <TextField
            variant="outlined"
            fullWidth
            label="Phone"
            name="phone"
            id="phone"
            error={!!errors.phone}
            helperText={errors.phone?.message}
            InputProps={{
              inputComponent: PhoneMask,
            }}
            inputRef={register({
              required: "Please enter a phone number",
              validate: (value) => {
                // Remove mask characters and placeholders
                const digits = value.replace(/\D/g, "");
                if (digits.length < 10) {
                  return "Please enter a valid 10-digit phone number";
                }
                return true;
              },
            })}
            />
            </Grid>)}

        {["signup", "signin", "forgotpass"].includes(props.type) && (
          <Grid item={true} xs={12}>
            <TextField
              variant="outlined"
              type="email"
              label="Email"
              name="email"
              placeholder="user@example.com"
              error={errors.email ? true : false}
              helperText={errors.email && errors.email.message}
              fullWidth={true}
              inputRef={register({
                required: "Please enter your email",
              })}
            />
          </Grid>
        )}

        {["signup", "signin", "changepass"].includes(props.type) && (
          <Grid item={true} xs={12}>
            <TextField
              variant="outlined"
              type="password"
              label="Password"
              name="pass"
              error={errors.pass ? true : false}
              helperText={errors.pass && errors.pass.message}
              fullWidth={true}
              inputRef={register({
                required: "Password is required",
                pattern: {
                  value: /^(?=.*[0-9])(?=.*[^A-Za-z0-9])/,
                  message: "Password must include at least one number and one symbol",
                },
                minLength: {
                  value: 8,
                  message: "Password must be at least 8 characters",
                },
              })}
            />
          </Grid>
        )}

        {["signup", "changepass"].includes(props.type) && (
          <Grid item={true} xs={12}>
            <TextField
              variant="outlined"
              type="password"
              label="Confirm Password"
              name="confirmPass"
              error={errors.confirmPass ? true : false}
              helperText={errors.confirmPass && errors.confirmPass.message}
              fullWidth={true}
              inputRef={register({
                required: "Please enter your password again",
                validate: (value) => {
                  if (value === getValues().pass) {
                    return true;
                  } else {
                    return "This doesn't match your password";
                  }
                },
              })}
            />
          </Grid>
        )}

        {["signup"].includes(props.type) && (
        <Grid item xs={12}>
          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              name="tosAccepted"
              style={{ marginRight: "8px" }}
              ref={register({
                required: "You must agree before creating an account",
              })}
            />
            <span>
              I agree to the{" "}
              <a style={{color: "#0059a6"}} href="https://shownav.net/showNAV_TermsOfService.pdf" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>{" "}
              and{" "}
              <a style={{color: "#0059a6"}} href="https://shownav.net/showNAV_PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </span>
          </label>

          {errors.tosAccepted && (
            <p style={{ color: "red", marginTop: "4px" }}>
              {errors.tosAccepted.message}
            </p>
          )}
        </Grid>
      )}

        <Grid item={true} xs={12}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={pending || !formState.isValid}
          fullWidth={true}
        >
          {!pending && <span>{props.buttonAction}</span>}
          {pending && <CircularProgress size={28} />}
        </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default AuthForm;
